// import React from "react";

// function ContactHero() {
//   return (
//     <div
//       className="contact-hero section-padding"
//       style={{
//         background: "radial-gradient(circle at 12% 23%, rgba(200, 150, 255, 0.12) 0%, transparent 60%), radial-gradient(circle at 88% 77%, rgba(100, 200, 255, 0.12) 0%, transparent 60%), #ffffff",
//         padding: "120px 0 80px",
//         position: "relative",
//         overflow: "hidden"
//       }}
//     >
//       {/* Decorative background blurs */}
//       <div
//         className="position-absolute d-none d-lg-block"
//         style={{
//           width: "500px",
//           height: "500px",
//           background: "rgba(103, 58, 183, 0.05)",
//           filter: "blur(100px)",
//           top: "-150px",
//           right: "-150px",
//           borderRadius: "50%",
//           zIndex: 0
//         }}
//       />

//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-7">
//             <div className="content position-relative" style={{ zIndex: 1 }}>
//               <h4 className="sub-title fw-bold mb-3" style={{ color: "#673AB7", textTransform: "uppercase", letterSpacing: "2px", fontSize: "14px" }}>
//                 Get In Touch
//               </h4>
//               <h1 className="title mb-4" style={{
//                 fontSize: "clamp(32px, 5vw, 64px)",
//                 fontWeight: "900",
//                 lineHeight: "1.1",
//                 letterSpacing: "-2px",
//                 color: "#1d1d1f"
//               }}>
//                 Let's Build the <br />
//                 <span style={{
//                   background: "linear-gradient(90deg, #673AB7, #2196F3)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent"
//                 }}>Future of Web3</span> Together
//               </h1>
//               <p className="mt-4 text-muted" style={{
//                 fontSize: "19px",
//                 maxWidth: "600px",
//                 lineHeight: "1.7",
//                 fontWeight: "500"
//               }}>
//                 Have a project in mind or just want to say hello? Our team of experts
//                 is ready to help you navigate the decentralized landscape.
//               </p>
//             </div>
//           </div>
//           <div className="col-lg-5">
//             <div className="thumb text-center mt-5 mt-lg-0 position-relative" style={{ zIndex: 1 }}>
//               <img
//                 src="/assets/img/illustration/contact_us_premium_3d.png"
//                 alt="Contact Xeer"
//                 className="img-fluid"
//                 style={{
//                   maxHeight: "450px",
//                   animation: "floatSoft 6s ease-in-out infinite",
//                   filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.08))"
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ContactHero;

// import React from "react";
// import { FaEnvelope, FaPhoneAlt, FaArrowRight } from "react-icons/fa";

// function ContactHero() {
//   return (
//     <section
//       className="position-relative overflow-hidden"
//       style={{
//         background:
//           "linear-gradient(135deg, #031B3A 0%, #071F45 35%, #0B2A59 100%)",
//         padding: "170px 0 120px",
//       }}
//     >
//       {/* Glow Effects */}
//       <div
//         style={{
//           position: "absolute",
//           top: "-120px",
//           left: "-120px",
//           width: "420px",
//           height: "420px",
//           background: "rgba(59,130,246,0.18)",
//           filter: "blur(120px)",
//           borderRadius: "50%",
//           zIndex: 0,
//         }}
//       />

//       <div
//         style={{
//           position: "absolute",
//           bottom: "-150px",
//           right: "-100px",
//           width: "450px",
//           height: "450px",
//           background: "rgba(37,99,235,0.18)",
//           filter: "blur(120px)",
//           borderRadius: "50%",
//           zIndex: 0,
//         }}
//       />

//       {/* Grid Overlay */}
//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           backgroundImage:
//             "linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)",
//           backgroundSize: "60px 60px",
//           opacity: 0.25,
//           zIndex: 0,
//         }}
//       />

//       <div className="container position-relative" style={{ zIndex: 2 }}>
//         <div className="row align-items-center">
//           {/* LEFT CONTENT */}
//           <div className="col-lg-7">
//             <div className="pe-lg-5">
//               {/* Badge */}
//               <div
//                 className="d-inline-flex align-items-center gap-2 mb-4"
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "999px",
//                   background: "rgba(255,255,255,0.08)",
//                   border: "1px solid rgba(255,255,255,0.12)",
//                   backdropFilter: "blur(10px)",
//                 }}
//               >
//                 <span
//                   style={{
//                     width: "8px",
//                     height: "8px",
//                     borderRadius: "50%",
//                     background: "#3B82F6",
//                     boxShadow: "0 0 12px #3B82F6",
//                   }}
//                 />
//                 <span
//                   style={{
//                     color: "#DCE8FF",
//                     fontWeight: 600,
//                     fontSize: "13px",
//                     letterSpacing: "1px",
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Contact Xeer Technology
//                 </span>
//               </div>

//               {/* Heading */}
//               <h1
//                 style={{
//                   fontSize: "clamp(42px, 6vw, 82px)",
//                   lineHeight: "1.05",
//                   fontWeight: 900,
//                   color: "#fff",
//                   letterSpacing: "-3px",
//                   marginBottom: "28px",
//                 }}
//               >
//                 Build Your
//                 <br />
//                 <span
//                   style={{
//                     background:
//                       "linear-gradient(90deg, #60A5FA 0%, #93C5FD 50%, #ffffff 100%)",
//                     WebkitBackgroundClip: "text",
//                     WebkitTextFillColor: "transparent",
//                   }}
//                 >
//                   Web3 Vision
//                 </span>
//               </h1>

//               {/* Description */}
//               <p
//                 style={{
//                   color: "rgba(255,255,255,0.72)",
//                   fontSize: "19px",
//                   lineHeight: "1.9",
//                   maxWidth: "620px",
//                   marginBottom: "38px",
//                   fontWeight: 400,
//                 }}
//               >
//                 Partner with Xeer Technology to create powerful blockchain,
//                 crypto exchange, DeFi, AI, and Web3 solutions designed for the
//                 next generation of digital innovation.
//               </p>

//               {/* Buttons */}
//               <div className="d-flex flex-wrap gap-3">
//                 <a
//                   href="/contact-us"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #2563EB 0%, #3B82F6 100%)",
//                     color: "#fff",
//                     padding: "16px 34px",
//                     borderRadius: "16px",
//                     fontWeight: 700,
//                     textDecoration: "none",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: "10px",
//                     boxShadow: "0 15px 40px rgba(37,99,235,0.35)",
//                     transition: "0.3s ease",
//                   }}
//                 >
//                   Start Your Project
//                   <FaArrowRight />
//                 </a>

//                 <a
//                   href="mailto:info@xeertech.com"
//                   style={{
//                     background: "rgba(255,255,255,0.06)",
//                     border: "1px solid rgba(255,255,255,0.14)",
//                     color: "#fff",
//                     padding: "16px 28px",
//                     borderRadius: "16px",
//                     fontWeight: 600,
//                     textDecoration: "none",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: "10px",
//                     backdropFilter: "blur(12px)",
//                   }}
//                 >
//                   <FaEnvelope />
//                   Email Us
//                 </a>
//               </div>

//               {/* Contact Mini Cards */}
//             </div>
//           </div>

//           {/* RIGHT IMAGE */}
//         </div>
//       </div>

//       {/* Animation */}
//       <style>
//         {`
//           @keyframes floatAnimation {
//             0% {
//               transform: translateY(0px);
//             }
//             50% {
//               transform: translateY(-18px);
//             }
//             100% {
//               transform: translateY(0px);
//             }
//           }
//         `}
//       </style>
//     </section>
//   );
// }

// export default ContactHero;

import React from "react";
import { FaEnvelope, FaArrowRight } from "react-icons/fa";

function ContactHero() {
  return (
    <section
      className="position-relative overflow-hidden d-flex align-items-center justify-content-center text-center"
      style={{
        background:
          "linear-gradient(135deg, #031B3A 0%, #071F45 35%, #0B2A59 100%)",
        minHeight: "100vh",
        padding: "140px 20px 100px",
      }}
    >
      {/* Glow Effects */}
      <div
        style={{
          position: "absolute",
          top: "-120px",
          left: "-120px",
          width: "420px",
          height: "420px",
          background: "rgba(59,130,246,0.18)",
          filter: "blur(120px)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: "-150px",
          right: "-100px",
          width: "450px",
          height: "450px",
          background: "rgba(37,99,235,0.18)",
          filter: "blur(120px)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      />

      {/* Grid Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
          opacity: 0.25,
          zIndex: 0,
        }}
      />

      <div
        className="container position-relative"
        style={{ zIndex: 2, maxWidth: "950px" }}
      >
        {/* Badge */}
        <div
          className="d-inline-flex align-items-center gap-2 mb-4"
          style={{
            padding: "10px 18px",
            borderRadius: "999px",
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.12)",
            backdropFilter: "blur(10px)",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              background: "#3B82F6",
              boxShadow: "0 0 12px #3B82F6",
            }}
          />

          <span
            style={{
              color: "#DCE8FF",
              fontWeight: 600,
              fontSize: "13px",
              letterSpacing: "1px",
              textTransform: "uppercase",
            }}
          >
            Contact Xeer Technology
          </span>
        </div>

        {/* Heading */}
        <h1
          style={{
            fontSize: "clamp(42px, 6vw, 88px)",
            lineHeight: "1.05",
            fontWeight: 900,
            color: "#fff",
            letterSpacing: "-3px",
            marginBottom: "28px",
          }}
        >
          Build Your
          <br />
          <span
            style={{
              background:
                "linear-gradient(90deg, #60A5FA 0%, #93C5FD 50%, #ffffff 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Web3 Vision
          </span>
        </h1>

        {/* Description */}
        <p
          className="mx-auto"
          style={{
            color: "rgba(255,255,255,0.72)",
            fontSize: "20px",
            lineHeight: "1.9",
            maxWidth: "760px",
            marginBottom: "42px",
            fontWeight: 400,
          }}
        >
          Partner with Xeer Technology to create powerful blockchain, crypto
          exchange, DeFi, AI, and Web3 solutions designed for the next
          generation of digital innovation.
        </p>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3">
          <a
            href="/contact-us"
            style={{
              background: "linear-gradient(135deg, #2563EB 0%, #3B82F6 100%)",
              color: "#fff",
              padding: "16px 34px",
              borderRadius: "16px",
              fontWeight: 700,
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              boxShadow: "0 15px 40px rgba(37,99,235,0.35)",
              transition: "0.3s ease",
            }}
          >
            Start Your Project
            <FaArrowRight />
          </a>

          <a
            href="mailto:info@xeertech.com"
            style={{
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.14)",
              color: "#fff",
              padding: "16px 28px",
              borderRadius: "16px",
              fontWeight: 600,
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              backdropFilter: "blur(12px)",
            }}
          >
            <FaEnvelope />
            Email Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactHero;
